<script setup>
  import { computed, defineProps } from 'vue';
  import trendingUpIcon from 'assets/icons/trending_up.svg';
  import activitySignalIcon from 'assets/icons/activity_signal.svg';

  const props = defineProps({
    text: {
      type: String,
      default: '',
      required: true,
    },
    icon: {
      type: String,
      default: 'trending_up',
    },
  });

  const icons = {
    trending_up: trendingUpIcon,
    activity_signal: activitySignalIcon,
  };

  const computedIcon = computed(() => {
    return icons[props.icon];
  });
</script>

<template>
  <div class="content flex gap-2">
    <span class="icon" v-html="computedIcon"> </span>
    <span class="text">{{ text }}</span>
  </div>
</template>

<style scoped lang="scss">
  .content {
    margin-bottom: 16px;
    padding: 8px;
    background-color: #eaeafa;
    border-radius: 8px;
    align-items: center;
    max-width: fit-content;
  }
  .icon {
    width: 18px;
    height: 18px;
  }
  .text {
    color: #2525a7;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
  }
</style>
